/*

Utilities for optional functions.

*/

// SCOPE:
// So that we can talk to the outer iframe if needed.
var _scope = window.top.document;

//-----------------------------
// Object and Array Helpers
//-----------------------------

var functions = { 
  
  cloneArray: function(array){
    return array.slice(0);
  },

  clone: function(obj){
    return JSON.parse(JSON.stringify(obj));
  },

  href_replace: function(str, find, replace){

    if(typeof str == "undefined"){
      return str; 
    }

    //Replace all occurrences of this link prefix
    var str = str.replace(new RegExp('href="'+find, 'g'), 'href="'+replace);

    //Replace all the ones with single quotes in Vue template inline JS
    var str = str.replace(new RegExp('href="\''+find, 'g'), 'href="\''+replace);

    return str;

  },

  //-----------------------------
  // Link Fixers
  //-----------------------------

  fixLinks: function(html){

    console.log(html);

    //If not enabled, then return HTML unedited
    if(!_scope.Creek.config.shows.router.enable){
      return html;
    }

    for(find in _scope.Creek.config.shows.router.linkReplacements){
      html = href_replace(html, find, _scope.Creek.config.shows.router.linkReplacements[find]);
    }

    // console.log(3);
    // console.log(newDataPlusDefaults.shows.router.pathPrefix);

    return html;

  },

  getURLHost: function(url){
    var tmp = document.createElement('a');
    tmp.href = url;
    return tmp.hostname;
  },

  //-------------------------------
  // Images
  //-------------------------------

  images: {

    imageExists: function(image_url){

      var http = new XMLHttpRequest();

      http.open('HEAD', image_url, false);
      http.send();

      return http.status != 404;

    }

  },

  capitalizeFirstLetter: function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },


  //-------------------------------
  // Browser Detection Helpers
  //-------------------------------

  /*
  TODO:
  - Use feature detection instead of browser checks.
  - But first, figure out what features are needed
  */

  browserChecks: {

    chrome: function(){

      var isChromium = window.chrome,
          winNav = window.navigator,
          vendorName = winNav.vendor,
          isOpera = winNav.userAgent.indexOf("OPR") > -1,
          isIEedge = winNav.userAgent.indexOf("Edge") > -1,
          isIOSChrome = winNav.userAgent.match("CriOS");

      var itsChrome = false;

      // is Google Chrome on IOS
      if(isIOSChrome){
        itsChrome = true;
      }
      // is Google Chrome
      else if(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera == false && isIEedge == false) {
        itsChrome = true;
      }
      // not Google Chrome
      else {
        itsChrome = false;
      }

      return itsChrome;

    },

    firefox: function(){
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    },

    safari: function() {

      if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        return true;
      }
      else{
        return false;
      }

    },

    internetExplorer: function() {

      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      // other browser
      return false;

    },

    edge: function() {

      var ua = window.navigator.userAgent;

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;

    },

    opera: function() {

      return navigator.userAgent.match(/Opera|OPR\//) ? true : false;

    },

    facebook: function() {
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      var isFacebook = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
      return isFacebook;
    }

  },

}

//-------------------------------
// Google Analytics
//-------------------------------

// Safe Google Analytics Shim
functions.ga = function(action, type, eventCategory, eventAction, eventLabel, eventValue, fieldsObject){

  fieldsObject = fieldsObject || null;

  if (typeof ga != 'undefined') {
    ga(action, type, eventCategory, eventAction, eventLabel, eventValue, fieldsObject);
  }

}

// Alias of GA Shim (above)
functions.GoogleAnalytics = functions.ga;


//-------------------------------
// Cookies
//-------------------------------
functions.cookies = {

  create: function(name,value,seconds) {
    if (seconds) {
      var date = new Date();
      date.setTime(date.getTime()+(seconds));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  },

  read: function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

}
functions.cookies.destroy = function(name) {
  functions.cookies.create(name,"",-1);
};


export default functions;
